import { ReviewInterface, UserInterface, DiverCertification, scoreProps, ScoreCard, SlimUserInterface, TripDb } from "./interfaces";
import {sanityClient} from "./service/external/sanity-client";
import {getCountriesPath, getTripsPath, getArticlesPath, getDocsPath} from "./service/util";

export type {ReviewInterface, UserInterface, DiverCertification, SlimUserInterface, ScoreCard, TripDb}

export {sanityClient, getCountriesPath, getArticlesPath, getTripsPath, getDocsPath, scoreProps}
